/**
 * <s-favorites-signup> wraps the Favorites page account form, revealed by the Save now <details> toggle.
 * With marketing consent ticked, the native customer form submits (creating the customer profile and the email subscription).
 * Without consent, the visitor goes to the store's secure sign-in, which creates the account without subscribing them.
 *   data-login-url — sign-in URL written by Liquid (routes.account_login_url)
 */
class FavoritesSignup extends HTMLElement {
  #onSubmit = (event) => {
    const consent = this.querySelector('[data-consent]');
    if (consent && !consent.checked) {
      event.preventDefault();
      const url = this.dataset.loginUrl;
      if (url) window.location.assign(url);
    }
  };

  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', this.#onSubmit);
    // Keep the panel open after a submit so the success or error message is visible.
    const panel = this.closest('details');
    if (panel && this.querySelector('[data-signup-result]')) panel.open = true;
  }

  disconnectedCallback() {
    this.querySelector('form')?.removeEventListener('submit', this.#onSubmit);
  }
}

if (!customElements.get('s-favorites-signup')) customElements.define('s-favorites-signup', FavoritesSignup);
